const Dot = ({ ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        {...props}
    >
        <circle cx="8" cy="12" r="6" fill="currentColor" />
    </svg>
);
export default Dot;
